module.exports = __webpack_public_path__ + "img/75@3x.a5a0e05e.png";